import React from 'react';
import DataGrid,{ Column, ColumnChooser, Export, FilterRow, Pager, Paging, SearchPanel } from 'devextreme-react/data-grid';
import { store } from '../../services/store';
import uri from '../../utils/uri';
import BlockHeader from '../shared/BlockHeader';
import Title from '../shared/Title';
import { updateSmsDialog } from '../../store/sms/smsReducer';
import CustomButton from '../buttons/CustomButton';
import {  useDispatch } from 'react-redux';
import Nuevo from './Nuevo';
import { formatDateTime } from '../../data/app';

const SMS = props => {
    const dispatch = useDispatch();
    
    const { clientId } = props;

    let dataGrid = React.createRef();

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'xlsxfile',
                type:'success',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.exportToExcel(false)
            }
        });
    }  

    const title = "Avisos y sms"

    return (
        <div>
            <Title title={title} />
            <BlockHeader title={title}>    
            {clientId != 0 && <CustomButton
                    text="Avisar"
                    icon='fas fa-mobile-alt'                   
                    onClick={()=>  dispatch(updateSmsDialog({ open: true,id : clientId}))}
                /> }          
            </BlockHeader>
            <Nuevo clientId={clientId}/>
            <DataGrid
                ref={dataGrid}
                dataSource={store({ uri: {
                        get : uri.sms.getByClientId(clientId)
                    }, remoteOperations : true
                })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                rowAlternationEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                remoteOperations={{
                    paging: true,
                    filtering: true
                }}    
            >                
                {clientId == 0 && <SearchPanel visible={true} width={250} placeholder="Buscar por número" />}
                <ColumnChooser enabled={true} />
                <Pager allowedPageSizes={[10, 15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                <Paging defaultPageSize={15} />
                <Export enabled={false} fileName={title} allowExportSelectedData={true} />
                <Column dataField="client" caption="Cliente" visible={clientId == 0} width={300} allowFiltering={false} />
                <Column dataField="phoneNumber" caption="Numero" width={120} />               
                <Column dataField="message" caption="Mensaje" allowFiltering={false} />
                <Column dataField="sentAt" caption="Fecha" width={160} dataType="date" format={formatDateTime} allowFiltering={false}/>
                <Column dataField="SendBy" caption="Enviado Por" width={150} visible={false} allowFiltering={false}/>
            </DataGrid>
        </div>
    );
}

export default SMS;
